import React from 'react';
import { NodePropertiesPanel } from './NodePropertiesPanel';
import { EdgePropertiesPanel } from './EdgePropertiesPanel';
import { InterfaceType } from '../../types/fta.types';

interface PropertiesPanelProps {
    selectedNode: any;
    selectedNodeId: string | null;
    selectedEdge: any;
    selectedEdgeId: string | null;
    updateSelectedNode: (key: string, value: any) => void;
    updateSelectedEdge: (type: InterfaceType) => void;
    setNodes: any;
    setSelectedNodeId: (id: string | null) => void;
    setEdges: any;
    setSelectedEdgeId: (id: string | null) => void;
}

export const PropertiesPanel: React.FC<PropertiesPanelProps> = ({
    selectedNode,
    selectedNodeId,
    selectedEdge,
    selectedEdgeId,
    updateSelectedNode,
    updateSelectedEdge,
    setNodes,
    setSelectedNodeId,
    setEdges,
    setSelectedEdgeId
}) => {
    if (!selectedNode && !selectedEdge) return null;

    return (
        <aside className="w-80 bg-white dark:bg-slate-800 border-l border-slate-200 dark:border-slate-700 p-6 z-10 shadow-lg overflow-y-auto transition-colors">
            <NodePropertiesPanel
                selectedNode={selectedNode}
                selectedNodeId={selectedNodeId}
                updateSelectedNode={updateSelectedNode}
                setNodes={setNodes}
                setSelectedNodeId={setSelectedNodeId}
            />
            <EdgePropertiesPanel
                selectedEdge={selectedEdge}
                selectedEdgeId={selectedEdgeId}
                updateSelectedEdge={updateSelectedEdge}
                setEdges={setEdges}
                setSelectedEdgeId={setSelectedEdgeId}
            />
        </aside>
    );
};
